var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 22C13.6495 22 16 19.5376 16 16.5C16 13.4624 13.6495 11 10.75 11C7.93773 11 5.64192 13.3165 5.50633 16.2275C5.28069 16.166 5.04399 16.1333 4.8 16.1333C3.2536 16.1333 2 17.4466 2 19.0667C2 20.6867 3.2536 22 4.8 22H10.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25167 14.8577C4.2956 14.8517 4.33978 14.8465 4.3842 14.8419C5.09229 11.914 7.63564 9.6875 10.75 9.6875C14.4312 9.6875 17.3125 12.7958 17.3125 16.5C17.3125 16.668 17.3066 16.8347 17.2949 17H18C20.2091 17 22 15.2091 22 13C22 10.7909 20.2091 9 18 9C17.6514 9 17.3133 9.04459 16.991 9.12836C16.7973 5.15887 13.5175 2 9.5 2C5.35786 2 2 5.35786 2 9.5C2 11.5989 2.86217 13.4964 4.25167 14.8577Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.e6f656d404b48d41f58c2ea78d5d70dc.svg";
export { ForwardRef as ReactComponent };